import { lazy } from "react";

export const ManageGradesAsync = lazy(() => import("./ManageGrades"));
